import { createFileRoute } from "@tanstack/react-router";
import { kennelMoreRoute, KennelMorePage } from "@/features/provider-home";

export const Route = createFileRoute("/kennel/_dashboard/more")({
    ssr: kennelMoreRoute.ssr,
    head: kennelMoreRoute.head,
    component: KennelMorePage,
});
